<div class="popup modal-header d-inline-block pb-0 w-100 m-auto">
  <div class="pop-up-header p-4 border-bottom d-flex justify-content-between w-100">
    <h2>Add Frequently Flyer Info</h2>
    <fa-icon [icon]="icons.close" (click)="close()" class="icon"></fa-icon>
  </div>

  <form [formGroup]="flyerForm" class="p-4">
    <!-- Frequent Flyer ID -->
    <div class="form-group mb-3">
      <label class="form-label">Frequent Flyer Number <span class="text-danger">*</span></label>
      <input type="text" class="form-control" formControlName="flyer_id" placeholder="B545607888" maxlength="30">
      <small class="text-danger" *ngIf="flyerForm.get('flyer_id')?.touched && flyerForm.get('flyer_id')?.errors?.flyerNumberLength">
        Flyer number must be between 5 and 30 characters.
      </small>
      <small class="text-danger" *ngIf="flyerForm.get('flyer_id')?.touched && flyerForm.get('flyer_id')?.errors?.flyerNumberFormat">
        Flyer number can only contain letters, numbers, and hyphens.
      </small>
    </div>

    <!-- Frequent Flyer IDX (Airline) -->
    <div class="form-group mb-4">
      <label class="form-label">Frequent Flyer Airline <span class="text-danger">*</span></label>
      <div class="airline-dropdown-wrapper">
        <div class="airline-select" (click)="toggleDropdown()" [class.active]="showAirlineDropdown">
          <span [class.placeholder]="!selectedAirline">
            {{ selectedAirline ? selectedAirline.name + ' (' + selectedAirline.iata_code + ')' : 'Select Airline' }}
          </span>
          <fa-icon [icon]="icons.chevronDown" class="chevron" [class.open]="showAirlineDropdown"></fa-icon>
        </div>
        <small class="text-danger" *ngIf="duplicateAirlineError">
          You already have a frequent flyer number for this airline.
        </small>
        <div class="airline-dropdown" *ngIf="showAirlineDropdown">
          <div class="search-box">
            <fa-icon [icon]="icons.search" class="search-icon"></fa-icon>
            <input type="text" [(ngModel)]="airlineSearch" [ngModelOptions]="{standalone: true}" (ngModelChange)="filterAirlines()" placeholder="Search by name or IATA code..." autocomplete="off">
          </div>
          <ul class="airline-list">
            <li *ngFor="let a of filteredAirlines" (click)="selectAirline(a)" [class.selected]="selectedAirline?.iata_code === a.iata_code">
              <span class="airline-name">{{ a.name }}</span>
              <span class="airline-code">{{ a.iata_code }}</span>
            </li>
            <li *ngIf="filteredAirlines.length === 0" class="no-results">No airlines found</li>
          </ul>
        </div>
      </div>
    </div>
  </form>

  <div class="footer p-4">
    <button class="btn btn-add" [disabled]="flyerForm.invalid || isSubmitting || duplicateAirlineError" (click)="add()">
      {{ isSubmitting ? 'Adding...' : 'Add' }}
    </button>
  </div>
</div>
